import React from 'react';
import { Link, useLocation } from 'react-router-dom';

interface LocationState {
  email?: string;
  name?: string;
}

export const SignupSuccessPage: React.FC = () => {
  const location = useLocation();
  const state = location.state as LocationState;
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        {/* Header */}
        <div className="text-center">
          <div className="mx-auto h-16 w-16 bg-green-600 rounded-full flex items-center justify-center mb-4">
            <i className="fas fa-check text-white text-2xl"></i>
          </div>
          <h2 className="text-3xl font-bold text-gray-900 mb-2">
            Inscription réussie !
          </h2>
          <p className="text-gray-600">
            Votre compte a été créé avec succès
          </p>
        </div>

        {/* Contenu */}
        <div className="bg-white rounded-xl shadow-lg p-8">
          <div className="text-center space-y-4">
            {state?.name && (
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                <p className="text-sm text-blue-800">
                  <i className="fas fa-user text-blue-600 mr-2"></i>
                  Bienvenue <strong>{state.name}</strong> !
                </p>
              </div>
            )}

            {state?.email && (
              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                <p className="text-sm text-yellow-800">
                  <i className="fas fa-envelope text-yellow-600 mr-2"></i>
                  Email de confirmation envoyé à : <strong>{state.email}</strong>
                </p>
              </div>
            )}

            <div className="text-left space-y-3 text-sm text-gray-600">
              <h3 className="font-semibold text-gray-900 text-center mb-3">
                Prochaines étapes :
              </h3>
              <div className="space-y-2">
                <p className="flex items-start">
                  <span className="bg-[#002c46] text-white rounded-full w-5 h-5 flex items-center justify-center text-xs mr-3 mt-0.5 flex-shrink-0">1</span>
                  Vérifiez votre boîte mail (et le dossier spam)
                </p>
                <p className="flex items-start">
                  <span className="bg-[#002c46] text-white rounded-full w-5 h-5 flex items-center justify-center text-xs mr-3 mt-0.5 flex-shrink-0">2</span>
                  Cliquez sur le lien de confirmation dans l'email
                </p>
                <p className="flex items-start">
                  <span className="bg-[#002c46] text-white rounded-full w-5 h-5 flex items-center justify-center text-xs mr-3 mt-0.5 flex-shrink-0">3</span>
                  Connectez-vous et choisissez votre rôle (étudiant-e, tuteur-trice, ou les deux)
                </p>
                <p className="flex items-start">
                  <span className="bg-[#002c46] text-white rounded-full w-5 h-5 flex items-center justify-center text-xs mr-3 mt-0.5 flex-shrink-0">4</span>
                  Complétez votre profil selon votre rôle
                </p>
              </div>
            </div>

            <div className="pt-4 space-y-3">
              <Link
                to="/verify-otp?type=signup"
                className="block w-full py-3 px-4 bg-[#002c46] text-white font-semibold rounded-lg hover:bg-[#001a2a] transition-colors text-center"
              >
                <i className="fas fa-key mr-2"></i>
                J'ai reçu un code, entrer le code
              </Link>
              
              <Link
                to="/login"
                className="block w-full py-3 px-4 border border-[#002c46] text-[#002c46] font-semibold rounded-lg hover:bg-[#002c46]/5 transition-colors text-center"
              >
                <i className="fas fa-sign-in-alt mr-2"></i>
                Aller à la page de connexion
              </Link>
              
              <Link
                to="/"
                className="block w-full py-3 px-4 border border-gray-300 text-gray-600 font-semibold rounded-lg hover:bg-gray-50 transition-colors text-center"
              >
                <i className="fas fa-home mr-2"></i>
                Retour à l'accueil
              </Link>
            </div>
          </div>
        </div>

        {/* Support */}
        <div className="text-center">
          <p className="text-sm text-gray-600 mb-2">
            Vous ne recevez pas l'email de confirmation ?
          </p>
          <Link
            to="/contact"
            className="text-[#002c46] hover:text-[#001a2a] font-medium text-sm"
          >
            <i className="fas fa-envelope mr-1"></i>
            Contactez-nous
          </Link>
        </div>
      </div>
    </div>
  );
};
